import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '../../../button/button.module';
import { InputBoxModule } from '../../../input-box/input-box.module';
import { InputColorBoxModule } from '../../../input-color-box/input-color-box.module';
import { ModalModule } from '../../../modal/modal.module';
import { RangeSliderModule } from '../../../range-slider/range-slider.module';
import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';
import { TreeListModule } from '../../../tree-list/tree-list.module';
import { HighlightConfigFormComponent } from './highlight-config-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ScrollViewModule,
    InputBoxModule,
    InputColorBoxModule,
    RangeSliderModule,
    ButtonModule,
    TreeListModule,
    ModalModule,
  ],
  declarations: [HighlightConfigFormComponent],
  exports: [HighlightConfigFormComponent],
})
export class HighlightConfigFormModule {}
